/**
 * Subtle "data is refreshing" indicator for a panel that keeps showing its
 * last result while a new query is in flight (live-edit config, filter
 * tweaks). A thin pulsing bar along the top edge: the chart underneath stays
 * readable and never flashes to the full loading state.
 *
 * Mount inside a `relative` container.
 */
export function PanelRefreshing() {
  return (
    <div
      role="status"
      aria-label="Refreshing"
      data-testid="panel-refreshing"
      className="pointer-events-none absolute inset-x-0 top-0 z-10 h-0.5 overflow-hidden"
    >
      <div className="h-full w-full animate-pulse bg-primary/70" />
    </div>
  )
}
